import React from "react";
import { useGlobalContext } from "../../scanview/ScanViewerContext";
import CameraPermissionModal from "./components/CameraPermissionModal/CameraPermissionModal";
import GeneralModal from "../GeneralModal/GeneralModal";
import WebToMobile from "./components/WebToMobile/WebToMobile";
import HelpModal from "./components/HelpModal/HelpModal";
import NoCameraModal from "./components/NoCameraModal/NoCameraModal";
import { isInApp } from "../../utils/getInfoFunctions";
import { useScanVideoContext } from "../../scanview/contexts/ScanVideoContext";

const ErrorModal = () => {
  const {
    cameraPermissionModalConfig,
    showErrorModal,
    webToMobileHandoffConfig,
  } = useGlobalContext();

  const { cameraPermissionState } = useScanVideoContext();

  const getAriaLabel = () => {
    if (showErrorModal.modal === "cameraPermission") {
      return "Camera Permission Error";
    } else if (showErrorModal.modal === "webToMobile") {
      return "Mobile Handoff Error";
    } else if (showErrorModal.modal === "help" && !isInApp()) {
      return "Help";
    } else if (showErrorModal.modal === "help" && isInApp()) {
      return "No Camera Available";
    }
    return "Error Modal";
  };

  return (
    <GeneralModal
      ariaLabel={getAriaLabel()}
      show={showErrorModal.show && cameraPermissionState !== "requesting"}
    >
      {cameraPermissionModalConfig?.enabled &&
        showErrorModal.modal === "cameraPermission" && (
          <CameraPermissionModal />
        )}
      {webToMobileHandoffConfig?.enabled !== false &&
        showErrorModal.modal === "webToMobile" && <WebToMobile />}
      {showErrorModal.modal === "help" && !isInApp() && <HelpModal />}
      {showErrorModal.modal === "help" && isInApp() && <NoCameraModal />}
    </GeneralModal>
  );
};

export default ErrorModal;
